import React, { Component } from "react";
import ReactDOM from "react-dom";

export default class NextArrow extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { right, style, top, theme } = this.props;
    const isMinimal = theme == "minimal";

    return (
      <a
        className="btn-floating btn-previous position-absolute btn-small z-depth-0 m-0 d-flex justify-content-center align-items-center"
        style={{
          ...style,
          top: !_.isEmpty(top) ? top : "50%",
          right: !_.isEmpty(right) ? right : "-45px",
          width: "33px",
          height: "33px",
          backgroundColor: isMinimal ? "transparent" : "#00000060",
        }}
        onClick={this.props.onClick}
      >
        <i
          className="fa fa-chevron-right"
          style={{ color: isMinimal ? "#00000060" : "white" }}
        ></i>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./resources/js/components/Shared/NextArrow.js